import { shape, bool, string, number } from "prop-types"

const Attendee = ({ attendeeSummary }) => {
  return (
    <div
      className={`action-drawer d-f ai-c jc-sb mb-1 ${
        attendeeSummary.canceled ? "c-tint3" : ""
      }`}
    >
      <div>{attendeeSummary.selectionName}</div>
      <div className="pr-1">{attendeeSummary.count}</div>
    </div>
  )
}

Attendee.propTypes = {
  attendeeSummary: shape({
    canceled: bool,
    selectionName: string,
    count: number,
  }),
}

export default Attendee
